import React from 'react';
import { InputNumber as AntInputNumber } from 'antd';
import type { InputNumberProps } from 'antd';
import clsx from 'clsx';

type ValueType = string | number;

export const InputNumber = <T extends ValueType = ValueType>({
  className,
  ...props
}: InputNumberProps<T>) => (
  <AntInputNumber<T>
    {...props}
    className={clsx('wk-input-number', className)}
  />
);
